import styled from 'styled-components';

export const QPopupBox = styled.div`
  padding: 4px;
  position: fixed;
  font-size: 14px;
  line-height: 20px;
  z-index: 2;
  border: solid;
  border-width: 1px;
  margin-left: -1px;
  color: ${({ theme }) => theme.palette.greyScaleDeprecated[2]};
  background: ${({ theme }) => theme.palette.greyScaleDeprecated[7]};
  border-color: ${({ theme }) => theme.palette.greyScaleDeprecated[0]};
`;

export const MenuItem = styled.div`
  color: ${({ theme }) => theme.palette.greyScaleDeprecated[0]};
  background: ${({ theme }) => theme.palette.greyScaleDeprecated[7]};
  &.active {
    &:hover {
      background: ${({ theme }) => theme.palette.greyScaleDeprecated[3]};
    }
    &:active {
      background: ${({ theme }) => theme.palette.greyScaleDeprecated[4]};
    }
  }
`;

export const HiddenInput = styled.input`
  position: fixed;
  height: 2px;
  width: 2px;
  opacity: 0;
`;

export const Separator = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.palette.greyScaleDeprecated[3]};
  margin-top: 2px;
  margin-bottom: 2px;
  height: 2px;

`;
